import type { KeyboardEvent } from 'react';
import React from 'react';

import Close from '@/icons/small/Cross-Naked.svg';

import { StyledIconCloseButton, StyledSearchInput } from './SearchForm.styled';

interface ISearchInputProps {
  query: string;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  cleanInput: () => void;
}

export const SearchInput = React.forwardRef<
  HTMLInputElement,
  ISearchInputProps
>(({ query, placeholder, onChange, onKeyDown, onFocus, cleanInput }, ref) => {
  return (
    <>
      <StyledSearchInput
        ref={ref}
        type="search"
        placeholder={placeholder}
        onFocus={onFocus}
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={query}
        name="searchInput"
        autoComplete="off"
      />
      {query && (
        <StyledIconCloseButton
          icon={<Close />}
          onClick={cleanInput}
          label="close"
          variant="primaryAlt"
          shape="square"
        />
      )}
    </>
  );
});

SearchInput.displayName = 'SearchInput';
